import React from 'react';
import FilterToggleGroup, { FilterToggleRow } from '../common/list/FilterToggleGroup';

const billTyps = [
  { id: 0, value: '', label: '전체', color: null },
  { id: 1, value: '매출', label: '매출', color: 'primary' },
  { id: 2, value: '매입', label: '매입', color: 'warning' },
];

const useYns = [
  { id: 0, value: '', label: '전체', color: null },
  { id: 1, value: 'Y', label: '완료', color: 'success' },
  { id: 2, value: 'N', label: '미완료', color: 'error' },
];

// 유형/완료 필터 - chancemng 설계(공통 FilterToggleGroup) 적용(2026-10-22).
const TaxbillStatusList = ({ searchBillTyp, onChangeBillTyp, searchYn, onChangeYn }) => {
  return (
    <FilterToggleRow>
      <FilterToggleGroup label="유형" options={billTyps} value={searchBillTyp} onChange={onChangeBillTyp} />
      <FilterToggleGroup label="완료" options={useYns} value={searchYn} onChange={onChangeYn} />
    </FilterToggleRow>
  );
};

export default TaxbillStatusList;
